import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import '../assets/styles/LetsTalk.css';
import ContactUs  from './Contactus';

const LetsTalk = () => {
    const [captchaValue, setCaptchaValue] = useState(null);

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (captchaValue === null) {
            alert("Please complete the captcha");
            return;
        }
        // Handle form submission logic here
        console.log("Form submitted!");
    };

    return (
     <div className="lets-talk">
  <div className="content-container">
    <div className="vertical-line"></div>
    <ContactUs /> {/* This should render a container with class "form-container" */}
    <div className="text-section">
      {/* <h1 className="title">Let's Talk</h1> */}
      <p className="subtitle">Let's Talk: Find Your Perfect Workforce</p>
      <p className="justified">
        Stop wasting time and resources on endless job postings and unqualified
        applicants. Let's Talk is your direct line to connecting with the skilled blue,
        grey, and general labor workers you need to keep your projects running smoothly.
      </p>
      <p className="justified">
        We understand the challenges: Finding reliable, qualified, and experienced
        workers for these critical roles can be a real headache. You need people who are
        ready to work, possess the right skills (or the willingness to learn), and fit your
        company culture. That's where we come in.
      </p>
      <p className="justified">
        Let's Talk is more than just a job board. We're building a community of talented
        individuals in various trades and industries, actively seeking opportunities. We
        specialize in connecting companies like yours with:
      </p>
      <ul>
        <li className="justified">
          Skilled Tradespeople: From electricians and plumbers to welders and carpenters,
          we've got you covered.
        </li>
        <li className="justified">
          Manufacturing &amp; Logistics Professionals: Find experienced machine operators,
          forklift drivers, warehouse workers, and more.
        </li>
        <li className="justified">
          Construction &amp; Engineering Specialists: Connect with qualified laborers,
          technicians, and project managers.
        </li>
        <li className="justified">
          General Labor: Need hardworking individuals for entry-level positions, site cleanup,
          material handling, and more? We can connect you with reliable general laborers ready
          to contribute.
        </li>
        <li className="justified">
          And much more! Whatever your blue, grey, or general labor staffing needs, we can
          help.
        </li>
      </ul>
      <p className="justified">Why Choose Let's Talk?</p>
      <ul>
        <li className="justified">
          Targeted Reach: We focus specifically on blue, grey, and general labor jobs,
          ensuring your postings reach the right candidates.
        </li>
        <li className="justified">
          Streamlined Process: Easily post your open positions, review applications, and
          connect with potential hires.
        </li>
        <li className="justified">
          Quality Candidates: We're committed to building a network of qualified and reliable
          workers.
        </li>
        <li className="justified">
          Dedicated Support: Our team is here to assist you every step of the way.
        </li>
      </ul>
      <p className="justified">Ready to build your dream team?</p>
      <p className="justified">
        Let's Talk! Contact us today to discuss your hiring needs and learn how we can help
        you find the perfect fit.
      </p>
      <button className="btn btn-primary">Post a Job</button>
      <p className="justified">
        We're not just filling positions; we're building careers and strengthening businesses.
        Let's Talk is your partner in workforce solutions, from skilled trades to general labor.
      </p>
    </div>
  </div>
</div>


    );
};

export default LetsTalk;
